import React, { useEffect, useState } from "react";
import { Row, Col, Card, Input, Typography, Table, Tag, Tooltip } from "antd";
import { SearchOutlined, UserDeleteOutlined } from "@ant-design/icons";
import moment from "moment";
import axiosNew from "../../store/api/axiosNew";

const { Title } = Typography;

const RetailDisqualifiedLeads = () => {
  const [disqualifiedLeads, setDisqualifiedLeads] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);

  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    total: 0,
  });

  const fetchDisqualifiedLeads = async (page = 1, limit = 10, search = "") => {
    try {
      setLoading(true);
      const token = localStorage.getItem("accessToken");

      const res = await axiosNew.get(
        "https://stageapilead.blaccdot.com/api/admin/disqualified-leads",
        {
          headers: { Authorization: `Bearer ${token}` },
          params: { page, limit, search },
        }
      );

      // Extract array from res.data.data and total count from res.data.count
      setDisqualifiedLeads(res.data?.data || []);
      setPagination({
        page: page,
        limit: limit,
        total: res.data?.count || 0,
      });
    } catch (error) {
      console.error("Failed to fetch disqualified leads", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDisqualifiedLeads(1, pagination.limit, "");
  }, []);

  const columns = [
    {
      title: "Lead Details",
      key: "leadInfo",
      width: 200,
      fixed: "left",
      render: (_, record) => {
        const lead = record.lead || {};
        return (
          <div>
            <div style={{ fontWeight: "bold", color: "#1890ff" }}>
              {lead.name || "N/A"}
            </div>
            <div style={{ fontSize: "12px", color: "#666" }}>
              ID: {lead._id || "N/A"}
            </div>
            <div style={{ fontSize: "12px", color: "#222427" }}>
              {lead.phone || "N/A"}
            </div>
          </div>
        );
      },
    },
    {
      title: "Disqualified By (User)",
      key: "disqualifiedBy",
      width: 180,
      render: (_, record) => {
        const purchase = record.purchase || {};
        return (
          <div>
            <div style={{ fontWeight: 600 }}>
              {purchase.userName || "N/A"}
            </div>
            <div style={{ fontSize: "12px", color: "#888" }}>
              {purchase.userEmail || ""}
            </div>
          </div>
        );
      },
    },
    {
      title: "Reason / Feedback",
      key: "reason",
      width: 260,
      render: (_, record) => {
        const reason = record.purchase?.disqualifiedReason;
        return (
          <Tooltip title={reason}>
            <div
              style={{
                background: "#fff2f0",
                border: "1px solid #ffccc7",
                padding: "6px 10px",
                borderRadius: "6px",
                color: "#cf1322",
                fontSize: "13px",
                whiteSpace: "normal",
                wordBreak: "break-word",
              }}
            >
              {reason || "No reason provided"}
            </div>
          </Tooltip>
        );
      },
    },
    {
      title: "Disqualified Date",
      key: "createdAt",
      width: 130,
      render: (_, record) => {
        const date = record.purchase?.purchaseDate;
        return date ? moment(date).format("DD-MM-YYYY") : "N/A";
      },
    },
    {
      title: "Category & Location",
      key: "categoryLocation",
      width: 200,
      render: (_, record) => {
        const lead = record.lead || {};
        return (
          <div style={{ fontSize: "12px" }}>
            <Tag color="blue">{lead.landType || "N/A"}</Tag>
            <div style={{ marginTop: 4, color: "#555" }}>
              {lead.location || "N/A"}
            </div>
          </div>
        );
      },
    },
    {
      title: "Budget",
      key: "budget",
      width: 120,
      render: (_, record) => {
        const amount = record.lead?.budget;
        return amount ? (
          <span style={{ fontWeight: 600 }}>
            ₹{Number(amount).toLocaleString()}
          </span>
        ) : (
          "N/A"
        );
      },
    },
  ];

  const handleTableChange = (paginationInfo) => {
    fetchDisqualifiedLeads(
      paginationInfo.current,
      paginationInfo.pageSize,
      searchTerm
    );
  };

  return (
    <div style={{ padding: "20px", background: "#f5f5f5", minHeight: "100vh" }}>
      {/* Header Title */}
      <Row justify="space-between" align="middle" style={{ marginBottom: 20 }}>
        <Col>
          <Title
            level={3}
            style={{ margin: 0, display: "flex", alignItems: "center", gap: 8 }}
          >
            <UserDeleteOutlined style={{ color: "#ff4d4f" }} />
            Retail Disqualified Leads
          </Title>
        </Col>
      </Row>

      {/* Main Table Card */}
      <Row>
        <Col span={24}>
          <Card
            style={{ width: "100%", borderRadius: "8px" }}
            bodyStyle={{ padding: 0 }}
            title="Disqualification Records"
            extra={
              <Input
                placeholder="Search leads, users, reasons..."
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  fetchDisqualifiedLeads(1, pagination.limit, e.target.value);
                }}
                prefix={<SearchOutlined style={{ color: "#888" }} />}
                style={{ width: 300 }}
              />
            }
          >
            <Table
              rowKey={(record) => record.lead?._id || record.purchase?.userId}
              columns={columns}
              dataSource={disqualifiedLeads}
              loading={loading}
              scroll={{ x: "max-content" }}
              pagination={{
                current: pagination.page,
                pageSize: pagination.limit,
                total: pagination.total,
                showTotal: (total) => `Total ${total} disqualified leads`,
              }}
              onChange={handleTableChange}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default RetailDisqualifiedLeads;